import { createContext } from "react";
import { ConnectedUser } from "../../types/ConnectedUser";

export type ConnectedUserContextType = {
  connectedUser: ConnectedUser;
  setConnectedUser: (c: ConnectedUser) => void;
};
export const ConnectedUserContext = createContext<ConnectedUserContextType>(undefined);
